export const BULK_OPERATION_THRESHOLD = 25;
export const BULK_OPERATION_CHUNK_SIZE = 100;
